var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.Base = function (superClass) {
  extend(Base, superClass);
  function Base() {
    return Base.__super__.constructor.apply(this, arguments);
  }
  Base.prototype.initialize = function (options) {
    _.defaults(options, {
      minimumInputLength: 2,
      matcher: function (term, text) {
        return true;
      },
      formatResult: this.formatResult,
      formatResultCssClass: this.formatResultCssClass,
      formatSelection: this.formatSelection
    });
    _.defaults(options.ajax, {
      dataType: 'json',
      quietMillis: 100
    });
    this.$el.select2(options).on('change', function (_this) {
      return function (e) {
        return _this.change(e);
      };
    }(this)).on('select2-opening', function (_this) {
      return function () {
        return _this.opening();
      };
    }(this)).on('select2-open', function (_this) {
      return function () {
        return _this.open();
      };
    }(this)).on('select2-close', function (_this) {
      return function () {
        return _this.close();
      };
    }(this));
    if (this.collection) {
      this.resetData();
      return this.listenTo(this.collection, 'add remove change error', this.resetData, this);
    }
  };
  Base.prototype._getDefaults = function () {};
  Base.prototype.change = function (e) {
    var item;
    if (item = e.added) {
      return this.trigger('item-selected', item);
    } else if (item = e.removed) {
      return this.trigger('item-removed', item);
    }
  };
  Base.prototype.currentSearchString = function () {
    return this.$el.select2("container").find(".select2-search-field input").val();
  };
  Base.prototype.resetData = function () {
    return this.$el.select2('data', this.collection.models);
  };
  Base.prototype.opening = function () {};
  Base.prototype.open = function () {};
  Base.prototype.close = function () {};
  Base.prototype.formatSelection = function (data, container, escapeMarkup) {};
  Base.prototype.formatResult = function (result, container, query, escapeMarkup) {};
  Base.prototype.formatResultCssClass = function (item) {};
  Base.prototype.parse = function (piped_text) {};
  Base.prototype.remove = function () {
    this.$el.select2('destroy');
    return Base.__super__.remove.apply(this, arguments);
  };
  return Base;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;